import { useEffect, useMemo, useRef, useState } from "react";

import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import CancelIcon from "@mui/icons-material/Cancel";

import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";
import CONTACT from "Assets/Images/photo_mmd.jpg";
import { changeCallMode } from "Redux/contactSlice";
import { passengerData } from "./side/passengerData";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
};

export default function Calling() {
  const { isCalling } = useAppSelector((state) => state.contact);
  const { showSupportLeftSide, selectedPassenger } = useAppSelector((state) => state.supportSide);
  const [hover, setHover] = useState(false);

  const { height } = useWindowSize();
  const dispatch = useAppDispatch();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const passenger = passengerData[selectedPassenger - 1];

  return (
    <Fade in={isCalling} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Collapse in={isOpen}>
          <Stack direction="row" sx={{ py: 2, justifyContent: "center" }}>
            <img src={passenger.src} alt="contact" style={{ width: "70px", borderRadius: "50%" }} />
          </Stack>
          <Typography fontWeight="800" sx={{ textAlign: "center" }}>
            {" "}
            {passenger.name}
          </Typography>
        </Collapse>

        <Stack
          direction="row"
          sx={{
            width: isOpen ? "40%" : "90%",
            py: 2,
            justifyContent: "space-between",
            margin: "auto",
            transition: " all 0.3s ease-in-out",
          }}
        >
          <Button
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            sx={{
              transition: " all 0.3s ease-in-out",
              width: hover ? "100%" : "45%",
              "& .MuiButton-startIcon": {
                margin: "0",
              },
            }}
            onMouseEnter={(e) => {
              if (isOpen) {
                setHover(true);
              }
            }}
            onMouseLeave={(e) => {
              if (isOpen) {
                setHover(false);
              }
            }}
            startIcon={<CallIcon style={{ fontSize: "35px", margin: "0" }} />}
          />
          <Button
            onClick={() => dispatch(changeCallMode(false))}
            component="label"
            role={undefined}
            variant="contained"
            tabIndex={-1}
            sx={{
              width: "45%",
              display: hover ? "none" : "inline-flex",
              background: "#EA2723",
              "& .MuiButton-startIcon": {
                margin: "0",
                height: "35px",
              },
            }}
            startIcon={<CancelIcon style={{ fontSize: "35px", margin: "0" }} />}
          />
        </Stack>
      </Card>
    </Fade>
  );
}
